// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// 🧭 Routing global
import { BrowserRouter as Router } from "react-router-dom";

// 🌐 Contexte Web3 (MetaMask + Polygon)
import { Web3Provider } from "./context/Web3Context";

// 🧠 React 18 root
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <Web3Provider>
        <App />
      </Web3Provider>
    </Router>
  </React.StrictMode>
);
